module.exports = __webpack_public_path__ + "static/media/calendar.40e47683.svg";